<template>
  <div />
</template>

<script>
  import firebase from 'firebase/app';
  import 'firebase/auth';
  import { SIGN_UP_STEPS } from '@/helpers/enums';

  export default {
    name: 'VerifyEmail',

    props: {
      verificationCode: {
        type: String,
      },
      email: {
        type: String,
      },
      signinCode: {
        type: String,
      },
    },

    async mounted() {
      const code = this.$route.query.verificationCode;
      const email = this.$route.query.email;
      const signinCode = this.$route.query.signinCode;

      await this.$router.push('/lobby');

      try {
        if (firebase.auth().currentUser) {
          return;
        }
        const link = `${window.location.origin}/action?apiKey=${process.env.VUE_APP_FIREBASE_API_KEY}&oobCode=${signinCode}&mode=signIn`;

        const emailVerified = await this.$store.dispatch('isEmailVerified', email);

        if (emailVerified) {
          await this.$store.dispatch('showAlertDialog', {
            title: 'Email already verified',
            text: 'Your email is already verified, please log in.',
          });
          return;
        }

        await firebase.auth().applyActionCode(code);
        await this.$store.dispatch('setEmailVerified', email);

        if (firebase.auth().isSignInWithEmailLink(link) && email) {
          await firebase.auth().signInWithEmailLink(email, link);
          await this.$store.dispatch('autoLogin');
          this.$store.dispatch('changeSignupStep', SIGN_UP_STEPS.VERIFY_PHONE);
          this.$store.dispatch('changeSignupDialogState', true);
          this.$store.dispatch('changeFirstSignInState', false);
        } else {
          await this.$store.dispatch('showAlertDialog', {
            title: 'Auto sign in failed',
            text: 'Wrong sign in url.',
          });
        }
      } catch (err) {
        if (err.code === 'auth/expired-action-code') {
          await this.$store.dispatch('showConfirmDialog', {
            title: 'The verification link has expired',
            text: 'Please request a new verification email.',
            yesText: 'Resend',
            noVisible: false,
            callback: () => {
              this.$store.dispatch('resendVerificationEmail', {
                email: email,
              });
            },
          });
        } else {
          await this.$store.dispatch('showConfirmDialog', {
            title: 'Verification failed',
            text: err.message,
            yesText: 'Resend verification email',
            noVisible: false,
            callback: () => {
              this.$store.dispatch('resendVerificationEmail', {
                email: email,
              });
            },
          });
        }
      }
    },
  };
</script>
